import axios from "axios";
import { BASE_URL } from "./baseUrls";

import {
  InterceptorRequestHandler,
  InterceptorResponseErrorHandler,
  InterceptorResponseHandler,
} from "./InterceptorHandler";

import { CUSTOMER_API_URL } from "./urlMetaData";
import secureLocalStorage from "react-secure-storage";
import { AUTH_LOCAL_VARIABLES } from "../store/features/authSlice";

const CustomerService = axios.create({ baseURL: BASE_URL.CUSTOMER });

CustomerService.interceptors.request.use((req) =>
  InterceptorRequestHandler(req)
);

// Dynamically, setting baseURL based on active region
CustomerService.interceptors.request.use((config) => {
  const REGION = secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.REGION);
  if (!REGION) return config;
  config.baseURL = BASE_URL[REGION].CUSTOMER;
  return config;
});

CustomerService.interceptors.response.use(
  (res) => {
    InterceptorResponseHandler(res);
    return res;
  },
  (error) => {
    InterceptorResponseErrorHandler(error);
    return error;
  }
);

// APIS
export const getCustomerList = async ({
  clientHashId,
  page = 0,
  size = 10,
  filters,
}) => {
  return await CustomerService.post(CUSTOMER_API_URL.CUSTOMERS_LIST, {
    clientHashId,
    page,
    size,
    ...filters,
  });
};

export const getCustomerStatistics = async ({ clientHashId, dateRange }) => {
  const res = await CustomerService.post(CUSTOMER_API_URL.CUSTOMERS_STATS, {
    clientHashId,
    dateRange,
  });

  return res.data;
};

// Add Driver
export const OnboardDriver = async ({
  clientHashId,
  programHashId,
  formData,
}) => {
  const url = `${CUSTOMER_API_URL.ONBOARD_DRIVER}/${programHashId}/${clientHashId}`;
  const res = await CustomerService.post(url, formData);

  return res.data;
};

export const BulkOperationDriver = async ({ payload }) => {
  const res = await CustomerService.post(
    `${CUSTOMER_API_URL.BULK_OPERATION_DRIVER}`,
    payload
  );
  return res.data;
};

export const fetchBulkOnboardSummary = async (payload) => {
  const res = await CustomerService.get(
    `${CUSTOMER_API_URL.BULK_ONBOARD_SUMMARY}?page=${payload.page}&daterange=${payload.daterange}&size=${payload.size}&userHashId=${payload.userHashId}`
  );
  return res.data;
};

// expense management
export const getCategoryList = async ({
  page = 0,
  size = 10,
  filters = null,
  clientHashId = null,
}) => {
  const res = await CustomerService.post(
    `${CUSTOMER_API_URL.GET_EXPENSE_LIST}`,
    {
      page,
      size,
      ...filters,
      clientHashId,
    }
  );

  return res.data;
};

export const addNewCategory = async (payload) => {
  const res = await CustomerService.post(
    `${CUSTOMER_API_URL.ADD_NEW_CATEGORY}`,
    payload
  );

  return res.data;
};

export const updateCategoryStatus = async (payload) => {
  const res = await CustomerService.put(
    `${CUSTOMER_API_URL.UPDATE_CATEGORY_STATUS}`,
    payload
  );

  return res.data;
};

export const getAvailableCategoryList = async ({ clientHashId = null }) => {
  const res = await CustomerService.get(
    `${CUSTOMER_API_URL.GET_AVAILABLE_CATEGORY_LIST}/${clientHashId}`
  );

  return res.data;
};

export default CustomerService;
